<template>
	<div class="row">
		<div class="col-md-12 mb-2">
			<h4>SPBG REPORT</h4>
		</div>
		
		<div class="col-md-12">
			<el-card shadow="never" class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '10px', paddingBottom: '16px' }">
                    <div v-if="false" slot="header" class="clearfix">
                        <strong><span>SPBG REPORT</span></strong>
                    </div>
                    <div>
						<el-tabs v-model="activeName" @tab-click="handleClick">
							<el-tab-pane name="first">
								<span slot="label"><i class="el-icon-data-line"></i> Sales</span>
								<div class="px-0 tab-container-item">
									<ReportSales :tabIndex="0" :tabName="'spbg-sales'" :tabLabel="'Sales'"/>
								</div>
							</el-tab-pane>
							<el-tab-pane label="Losses" name="second" v-if="false">Losses</el-tab-pane>
							<el-tab-pane label="Margin" name="third" v-if="false">Margin</el-tab-pane>
						</el-tabs>
					</div>
			</el-card>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'
import $ from 'jquery';

import ReportSales from '@/views/pages/SPBG/Component/SPBGReportSales.vue'

export default{
	extends: Fuel,
	components:{
		ReportSales,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	data(){
		return {
            value: 0,
			activeName: 'first',

			outterheight: 160,
			screenHeight: window.innerHeight - 160,
		}
	},
	watch: {

	}, 
	computed:{

	},

    mounted(){
		this.$emit('childrenRoute');
		this.addTabNavClass();
		window.addEventListener('resize', this.setDivHeight);
    },
	beforeDestroy() {
        window.removeEventListener('resize', this.setDivHeight);
    },
    methods:{
		setDivHeight() {
          //this.screenHeight = window.innerHeight - this.outterheight;
        },
		addTabNavClass() {
			$(".el-tabs__nav-wrap").addClass("bg-white");
			$(".el-tabs__header").addClass("tab-nav");
		},
		handleClick(tab, event) {
			console.log(tab, event);
		}
	}
}
</script>

<style>
.tab-nav {
	background: #ffffff !important;
	margin-bottom: 0px !important;
}

.tab-container-item {
    overflow-y: auto;
    overflow-x: hidden;
}
</style>